import { combineEpics } from "redux-observable";
import {
    zohoPhaseFileEpic,
    zohoPhaseFileExtraEpic,
    zohoPhaseFourEpic,
    zohoPhaseOneEpic,
    zohoPhaseThreeEpic,
    zohoPhaseTwoEpic,
} from "./default";

export const zohoEpics = combineEpics(
    zohoPhaseOneEpic,
    zohoPhaseTwoEpic,
    zohoPhaseThreeEpic,
    zohoPhaseFourEpic,
    zohoPhaseFileEpic,
    zohoPhaseFileExtraEpic
);
